export function ConvertDateTimeToTimestamp(datetime) {
  let d = new Date(datetime);
  d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
  let timestamp = d.toISOString().slice(0, 19).replace("T", " ");

  return timestamp;
}

export const ISOToRelativeTime = (datetime) => {
  const date1 = new Date(datetime);
  const date2 = new Date(Date.now());

  // Ensure that `datetime` is parsed correctly as UTC
  const timeDifference = date2.getTime() - date1.getTime();

  const secondsDifference = timeDifference / 1000;
  const minutesDifference = secondsDifference / 60;
  const hoursDifference = minutesDifference / 60;
  const daysDifference = hoursDifference / 24;
  const monthsDifference =
    date2.getMonth() -
    date1.getMonth() +
    12 * (date2.getFullYear() - date1.getFullYear());

  if (Math.round(secondsDifference) === 0) {
    return `just now`;
  } else if (Math.round(secondsDifference) < 60) {
    return `${Math.round(secondsDifference)} secs ago`;
  }

  if (Math.round(minutesDifference) === 1) {
    return `${Math.round(minutesDifference)} min ago`;
  } else if (Math.round(minutesDifference) < 60) {
    return `${Math.round(minutesDifference)} mins ago`;
  }

  if (Math.round(hoursDifference) === 1) {
    return `${Math.round(hoursDifference)} hr ago`;
  } else if (Math.round(hoursDifference) < 24) {
    return `${Math.round(hoursDifference)} hrs ago`;
  }

  if (Math.round(daysDifference) === 1) {
    return `${Math.round(daysDifference)} day ago`;
  } else if (Math.round(daysDifference) < 30) {
    return `${Math.round(daysDifference)} days ago`;
  }

  if (Math.round(monthsDifference) === 1) {
    return `${Math.round(monthsDifference)} mo ago`;
  } else if (Math.round(monthsDifference) < 12) {
    return `${Math.round(monthsDifference)} mos ago`;
  }

  const yearsDifference = date2.getFullYear() - date1.getFullYear();
  if (yearsDifference === 1) {
    return `${yearsDifference} yr ago`;
  } else {
    return `${yearsDifference} yrs ago`;
  }
};

export const futureDate = (numberOfDays) => {
  const date = new Date();
  const futureDate = date.setDate(date.getDate() + numberOfDays);
  const newDate = new Date(futureDate);
  const defaultExpiryDate = newDate.toJSON().split("T")[0];

  return defaultExpiryDate;
};

export const currentDate = () => {
  const date = new Date();
  const currentDate = date.toJSON().split("T")[0];
  return currentDate;
};

export const FormatDateForInput = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const FormatDateToLocaleDateString = (date) => {
  // Format: Oct 4, 2024,
  const d = new Date(date);
  const options = { year: "numeric", month: "short", day: "numeric" };
  const formattedDate = d.toLocaleDateString("en-US", options);

  return formattedDate;
};

export const CalculateDaysInAdvance = (number) => {
  const numberOfDays = number;

  const today = new Date();
  const numOfDaysInMiliSeconds = numberOfDays * 24 * 60 * 60 * 1000;
  const datetimeInAdvance = new Date(today.getTime() + numOfDaysInMiliSeconds);

  return datetimeInAdvance;
};

export const FormatDatetimeToMySQL = (datetimeString) => {
  const datetime = new Date(datetimeString);
  const mysqlDatetime = datetime.toISOString().slice(0, 19).replace("T", " ");
  return mysqlDatetime;
};

export const CalculateTimeDifference = (datetimeString) => {
  const currentTime = new Date();
  const targetTime = new Date(datetimeString);
  const diff = currentTime - targetTime;

  if (diff < 24 * 60 * 60 * 1000) return true;

  return false;
};

export const AddDaysInAdvanceUsingTimestamp = (timestamp, numOfDays) => {
  const initialTimestamp = timestamp;
  const initialDate = new Date(initialTimestamp * 1000);

  const twoDaysInMilliseconds = numOfDays * 24 * 60 * 60 * 1000;
  const newDate = new Date(initialDate.getTime() + twoDaysInMilliseconds);

  const newTimestamp = Math.floor(newDate.getTime() / 1000);

  return newTimestamp;
};

export const CalculateDaysInAdvanceWithHours = (timestamp, hours) => {
  const initialTimestamp = timestamp;
  const initialDate = new Date(initialTimestamp * 1000);

  const numOfDays = hours / 24;

  const twoDaysInMilliseconds = numOfDays * 24 * 60 * 60 * 1000;
  const newDate = new Date(initialDate.getTime() + twoDaysInMilliseconds);

  const newTimestamp = Math.floor(newDate.getTime() / 1000);

  return newTimestamp;
};

export const TimestampToLocalizeDate = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const localizedDateString = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return localizedDateString;
};

export const IntlToRelativeTimeFormat = (timestamp) => {
  // Timestamp: "2024-05-28T02:20:00.000Z"

  const now = new Date();
  const date = new Date(timestamp);
  const diffInMs = now - date;

  const minutes = Math.floor(diffInMs / (1000 * 60));
  const hours = Math.floor(diffInMs / (1000 * 60 * 60));
  const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) {
    return `${years}y ago`;
  } else if (months > 0) {
    return `${months}mo ago`;
  } else if (days > 0) {
    return `${days}d ago`;
  } else if (hours > 0) {
    return `${hours}h ago`;
  } else {
    return `${minutes}m ago`;
  }
};

export const formatTimeToHourMinutesSecondsSplit = (duration) => {
  const durationSplit = duration.split(":");
  const minutes = parseInt(durationSplit[0]);
  const seconds = parseInt(durationSplit[1]);

  // Ensure inputs are valid numbers
  if (isNaN(minutes) || isNaN(seconds)) return "Invalid Input";

  // Convert total time to seconds
  const totalSeconds = minutes * 60 + seconds;

  // Calculate hours, remaining minutes, and remaining seconds
  const hours = Math.floor(totalSeconds / 3600);
  const remainingSeconds = totalSeconds % 3600;
  const formattedMinutes = Math.floor(remainingSeconds / 60);
  const formattedSeconds = remainingSeconds % 60;

  // Format time dynamically
  if (hours > 0) {
    return [
      hours.toString(), // Do not pad hours
      formattedMinutes.toString().padStart(2, "0"),
      formattedSeconds.toString().padStart(2, "0"),
    ].join(":");
  } else {
    return [
      formattedMinutes.toString().padStart(2, "0"),
      formattedSeconds.toString().padStart(2, "0"),
    ].join(":");
  }
};
